import {useContext} from "react"
import {ToastContext} from "@/library/toasts/toast-context"

export default function useToasts() {
    return useContext(ToastContext)
}
